export const coachingNuernbergFAQData = [
  {
    question: "Wo befindet sich Jörg Hörmann und wie ist er erreichbar?",
    answer: "Jörg Hörmann ist im Raum Roth / Fränkisches Seenland ansässig und betreut Klienten in der gesamten Metropolregion Nürnberg. Coaching-Sessions finden wahlweise am Rothsee (Outdoor), vor Ort beim Klienten oder remote per Video statt. Erreichbar unter 09171-9892118 oder per E-Mail an info@joerg-hoermann.de."
  },
  {
    question: "Welche Dienstleistungen werden angeboten?",
    answer: "Das Angebot umfasst Executive Coaching für Führungskräfte, Finanzcoaching für Privatpersonen sowie Outdoor-Coaching (Walk & Talk) am Rothsee. Alle Formate sind individuell zugeschnitten und können vor Ort, remote oder in der Natur stattfinden."
  },
  {
    question: "Wie kann ich Kontakt aufnehmen?",
    answer: "Am einfachsten über das kostenlose Erstgespräch – buchbar direkt im Online-Kalender unter zeeg.me/joerghoermann. Alternativ per Telefon (09171-9892118), E-Mail (info@joerg-hoermann.de) oder über das Kontaktformular auf der Website."
  },
  {
    question: "Warum Coaching am Rothsee statt in Nürnberg?",
    answer: "Die Natur am Rothsee bietet einen wissenschaftlich belegten Vorteil: Studien zeigen, dass Bewegung im Freien die kognitive Flexibilität steigert und kreative Problemlösung fördert. Statt Büro-Atmosphäre erhalten Sie ein Premium-Coaching-Erlebnis, das tiefere Reflexion und nachhaltigere Ergebnisse ermöglicht – nur 30 Minuten von Nürnberg entfernt."
  },
  {
    question: "Bieten Sie auch Coaching direkt in Nürnberg an?",
    answer: "Ja, ich bin flexibel. Coaching-Sessions sind vor Ort in Nürnberg (in Ihren Räumlichkeiten oder an einem neutralen Ort), remote per Video oder als Walk & Talk am Rothsee möglich. Viele Klienten aus Nürnberg wählen bewusst den Rothsee als inspirierende Alternative zum klassischen Büro-Setting."
  },
  {
    question: "Welche Coaching-Angebote gibt es für Nürnberg und die Region?",
    answer: "Ich biete Executive Coaching für Führungskräfte, Finanzcoaching für Privatpersonen sowie Outdoor-Coaching am Rothsee an. Alle Formate sind für Klienten aus Nürnberg, Roth, Schwabach, Erlangen und dem gesamten Landkreis Roth bequem erreichbar."
  },
  {
    question: "Wie läuft ein Erstgespräch ab?",
    answer: "Das kostenlose Erstgespräch dauert ca. 30 Minuten und findet telefonisch oder per Video statt. Wir klären Ihre Ziele, besprechen das passende Format (Präsenz, Outdoor oder remote) und ich gebe Ihnen eine ehrliche Einschätzung, ob und wie ich Sie unterstützen kann."
  },
  {
    question: "Wie weit ist der Rothsee von Nürnberg entfernt?",
    answer: "Der Rothsee liegt nur ca. 30 Autominuten südlich von Nürnberg im Fränkischen Seenland. Er ist über die A6 und B2 bestens erreichbar – auch für Klienten aus Schwabach, Erlangen oder Ingolstadt eine bequeme Anfahrt."
  }
];
